<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "show",
        key: "id",
        url: {},
        output: false,
        order: "create_time desc",
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/show/add",
        },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      menus: [
        {
          label: "展厅列表",
          name: "show_list",
          auth: "/admin/show/lists",
          // badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
        {
          label: "分类列表",
          name: "showcategory_list",
          auth: "/admin/showcategory/lists",
        },
      ],
      query: {},
      filters: [
        {
          label: "展厅分类",
          name: "category_id",
          value: 1,
          type: "select",
          dropList: [],
        },
        { label: "标题", name: "title", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: "ID",
          key: "id",
          width: 120,
          align: "center",
        },
        {
          title: "标题",
          key: "title",
          minWidth: 160,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.title;
            const sext = row.stitle;
            return h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "green",
                    },
                    domProps: {
                      title: text,
                    },
                  },
                  "标题：" + text
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "blue",
                    },
                    domProps: {
                      title: sext,
                    },
                  },
                  "副标题：" + sext
                ),
              ]);
            // return (
            //   <div>
            //     <div style={{ color: "green", "font-size": "14px" }}>
            //       标题：{text}
            //     </div>
            //     <div style={{ color: "blue", "font-size": "12px" }}>
            //       副标题：{sext}
            //     </div>
            //   </div>
            // );
          },
        },
        {
          title: "展厅分类",
          key: "category_name",
          minWidth: 100,
          align: "center",
        },
        {
          title: "用户标签",
          minWidth: 120,
          key: "tags_name",
          align: "center",
        },
        {
          title: "图片",
          key: "image",
          minWidth: 120,
          align: "center",
          viewimage: true,
        },
        {
          title: "跳转方式",
          key: "view",
          minWidth: 160,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.ext_a2;
            const stext = row.ext_a1;
            if (row.view == 5) {
              return h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "blue",
                    },
                    domProps: {
                      title: stext,
                    },
                  },
                  "跳转方式：" + stext
                ),
              ]);
              // return (
              //   <div>
              //     <div style={{ color: "blue", "font-size": "14px" }}>
              //       跳转方式：{stext}
              //     </div>
              //   </div>
              // );
            } else {
              return h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "green",
                    },
                    domProps: {
                      title: stext,
                    },
                  },
                  "appid：" + text
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "blue",
                    },
                    domProps: {
                      title: stext,
                    },
                  },
                  "跳转方式：" + stext
                ),
              ]);
              // return (
              //   <div>
              //     <div style={{ color: "green", "font-size": "14px" }}>
              //       appid：{text}
              //     </div>
              //     <div style={{ color: "blue", "font-size": "14px" }}>
              //       跳转方式：{stext}
              //     </div>
              //   </div>
              // );
            }
          },
        },
        // {
        //   title: "标签",
        //   minWidth: 120,
        //   key: "tag",
        //   align: "center",
        // },
        // {
        //   title: "点击次数",
        //   minWidth: 120,
        //   key: "click_count",
        //   align: "center",
        // },
        {
          title: "排序",
          align: "center",
          // sortable: 'custom',
          key: "sort",
          width: 90,
          editable: true,
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          switch: true,
          disabled: false,
        },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          minWidth: 170,
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [{ name: "auth", value: "/admin/show/edit" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="info"
                  style={{ margin: "4px 5px" }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
          auth: {
            edit: "/admin/show/edit",
            del: "/admin/show/del",
          },
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    loadLevelData() {
      let q = {
        model: "show",
      };
      $utils.api.load(`categorynotPagelist`, q).then((res) => {
        console.log(res, "222222");
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.category_id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "category_id") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
          console.log("dropList category_id", dropList);
        }
      });
    },
    toAdd() {
      $utils.url.push({
        name: "show_add",
        query: {
          action: "add",
        },
      });
    },
    toEdit(row) {
      let id = row.id;
      $utils.url.push({
        name: "show_edit",
        query: { action: "edit", kv: id },
      });
    },
  },
};
</script>
